export type BaseStoreAction = { type: string; payload: any };

export type ActionHandlers<ACTION, STATE> = {
    [action: string]: (state: STATE, payload: any) => STATE;
};

export abstract class AbstractStore<ACTION extends BaseStoreAction, STATE> {
    protected actions$ = new Rx.Subject<ACTION>();
    protected store$: Rx.BehaviorSubject<STATE>;

    constructor() {
        this.store$ = new Rx.BehaviorSubject(this.createInitialState());

        this.actions$.scan<STATE>(this.reducer.bind(this), this.createInitialState()).subscribe(this.store$);
    }

    abstract createInitialState(): STATE;
    abstract getActionHandlers(): ActionHandlers<ACTION, STATE>;

    protected reducer(state: STATE, action: ACTION) {
        const { type, payload } = action;
        const handler = this.getActionHandlers()[type];

        if (handler) {
            return handler.apply(this, [state, payload]);
        }

        console.warn(`No handler for [${type}] registered`);

        return state;
    }

    /**
     * Used for dispatching actions;
     * this method is protected as it's intended to write delegate functions for dispatching actions
     * eg: dispatchNewMessage(message: Type) -> will do dispatch({type: new_message, payload: message})
     * @param action
     * @protected
     */
    protected dispatch(action: ACTION) {
        this.actions$.onNext(action);
    }

    getStore$() {
        return this.store$;
    }
}
